/** Full-page loading spinner for auth checks and permission gates. */
export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" style={{ background: "hsl(var(--background))" }}>
      <div className="flex flex-col items-center gap-4">
        <div
          className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin"
          aria-hidden
        />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
}
